import type { Event } from "@/types/event";

export type EventDisplayStatus = "live" | "today" | "prep" | "planned" | "past";

type EventLike = Pick<Event, "startDate" | "endDate" | "status">;

function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

// Day/boundary comparison uses the runtime's local timezone. StatusPill runs
// client-side, so "today" means the user's local calendar day. If this is ever
// called server-side, pass an explicit `now` to avoid UTC off-by-one.
export function eventStatus(
  event: EventLike,
  now: Date = new Date(),
): EventDisplayStatus {
  const start = new Date(event.startDate);
  const end = new Date(event.endDate);
  const t = now.getTime();

  if (t > end.getTime()) return "past";
  if ((t >= start.getTime() && t <= end.getTime()) || event.status === "active")
    return "live";
  if (isSameDay(start, now) && t < start.getTime()) return "today";
  return "planned";
}
